export const newRow={
    academicCareer:'',
    academicStream:'',
    academicClass:'',
    examType:[],
    cscId:''
}

export const examTypeDropdown=[
   {label:'iACST', value:'iACST'},
   {label:'ANTHE', value:'ANTHE'},
   {label:'IAT', value:'IAT'},
]